import type { ToolResultTransformer } from './types'
import { fallbackTransformer } from './transformers/fallback'

const transformers = new Map<string, ToolResultTransformer>()

export function registerToolResultTransformer(
  toolName: string,
  transformer: ToolResultTransformer,
): void {
  transformers.set(toolName, transformer)
}

export function getToolResultTransformer(
  toolName: string,
): ToolResultTransformer {
  return transformers.get(toolName) ?? fallbackTransformer
}
